var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { SpacesApi } from './apis/spaces-api.interface';
import _ from 'lodash';
import { CooperationType } from '../enums';
import { PatSnapAvatar } from '@/types/avatar';
let SpaceCooperationRepositoryImpl = class SpaceCooperationRepositoryImpl {
    constructor(_spacesApi) {
        this._spacesApi = _spacesApi;
    }
    async getSpaceCooperation(spaceId) {
        return this._spacesApi.getSpaceCooperation(spaceId).then(res => {
            return _.map(res, (item) => {
                let receiverInfo = null;
                if (item.receiver_type === CooperationType.ACCOUNT) {
                    receiverInfo = {
                        userId: item.receiver_info.user_id,
                        companyId: item.receiver_info.company_id,
                        companyName: item.receiver_info.company_name,
                        email: item.receiver_info.email,
                        mobileNumber: item.receiver_info.mobile_number,
                        nickname: item.receiver_info.nickname,
                    };
                }
                else if (item.receiver_type === CooperationType.GROUP) {
                    receiverInfo = {
                        avatar: item.receiver_info.avatar,
                        avatarColor: item.receiver_info.avatar_color,
                        avatarPattern: item.receiver_info.avatar_pattern,
                        avatarValue: item.receiver_info.avatar_value,
                        companyId: item.receiver_info.company_id,
                        createdAt: item.receiver_info.created_at,
                        createdBy: item.receiver_info.created_by,
                        description: item.receiver_info.description,
                        id: item.receiver_info.id,
                        name: item.receiver_info.name,
                        policy: item.receiver_info.policy,
                        total: item.receiver_info.total,
                        updatedBy: item.receiver_info.updated_by,
                    };
                }
                return {
                    receiverId: item.receiver_id,
                    CooperationType: item.receiver_type,
                    receiverInfo,
                    // @ts-ignore todo
                    avatar: PatSnapAvatar.convertAvatar(item.receiver_info),
                };
            });
        });
    }
};
SpaceCooperationRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(SpacesApi)),
    __metadata("design:paramtypes", [typeof (_a = typeof SpacesApi !== "undefined" && SpacesApi) === "function" ? _a : Object])
], SpaceCooperationRepositoryImpl);
export { SpaceCooperationRepositoryImpl };
